module.exports = __webpack_public_path__ + "static/img/gold_bar_bg.a4a2ade3.png";